import React from 'react';
import botImg from '../../../assets/images/bot-head.svg'
import User from "../../../assets/images/user.png"

function BotTyping({typing, botProfile}) {
    return(
        typing === true ? 
            <div className="bot-msg-wrapper">
                <div style={{display: "flex", alignItems:"center"}}>
                <img src={botProfile} onError={(e) => ((e.target.src = User))} className="bot-img" alt="bot reply image"/>
                <div className="bot-typing">
                    <div className="dot"></div>
                    <div className="dot"></div>
                    <div className="dot"></div>
                </div>
                </div> 
            </div>
        :
            <></>
    )
}
export default BotTyping;
